// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","approveButton":"BuildApprovalControls__approveButton--Tq"};